import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer" style={{ backgroundColor: "#333333", color: "white", height: "50px" }}>
                <Container fluid={true}>
                    <Row>
                        <Col md={6}> © 2022 all rights reserved</Col>
                        <Col md={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Powered by ZingWorks LLP
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    )
}

export default Footer
